import { useContext, useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import SiteContext from '../AppContext';
import styles from './pdpBanner.module.scss';
import WhereToBuyWidget from '../PriceSpiderWidgets/WhereToBuyWidget';
import AccessibleButton from '../AccessibleButton/AccessibleButton';
import { useTranslation } from '../../lib/hooks';
import { isPriceSpiderSite } from '../../lib/pricespider';
import { getInternalPageFromString } from '../../lib/utils';
import { GatherLogo, GoSolutionsLogo, NowFreshLogo, PetcureanLogo, SummitLogo } from '../Icons';

/**
 * @param {object} [props] component props
 * @param {string} [props.productName] product name
 * @param {string} [props.whereToBuyLink] Link for where to buy CTA
 * @param {object}[props.externalIDs] external IDs from product
 * @param {boolean}[props.renderBanner] render banner or not
 * @returns {JSX.Element} react component for PDP Sticky Banner
 */
export default function PDPBanner({ productName, whereToBuyLink, externalIDs, renderBanner }) {
  const { brand, locale } = useContext(SiteContext);
  const [animIn, setAnimIn] = useState(false);
  const finalWhereToBuyLink = whereToBuyLink || getInternalPageFromString('where-to-buy');
  const { t } = useTranslation();

  const logos = {
    gather: GatherLogo,
    'go-solutions': GoSolutionsLogo,
    'now-fresh': NowFreshLogo,
    petcurean: PetcureanLogo,
    summit: SummitLogo,
  };

  const Logo = brand === '' ? PetcureanLogo : logos[brand];

  const [bannerRef, inView] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    setAnimIn(inView);
  }, [inView]);

  return (
    <div
      className={`${styles.container} ${animIn && renderBanner && styles['slide-up']}`}
      ref={bannerRef}>
      <div className={styles.leftContainer}>
        <div className={styles.logo}>
          <Logo title={brand} />
        </div>
        <p className={styles.productName}>{productName}</p>
      </div>
      {isPriceSpiderSite(brand, locale) ? (
        <WhereToBuyWidget sku={externalIDs.sku} />
      ) : (
        <AccessibleButton type="primary" theme="dark" link={finalWhereToBuyLink}>
          {t('hero.whereToBuy')}
        </AccessibleButton>
      )}
    </div>
  );
}
